export default __webpack_public_path__ + "locales/hy-AM/ArchiveDialog.json?hash=7b535c605265bf97ae20a1ee4b8168ae";